import events from './config/carEvents';
import CarsRoutes from './cars-routes';
import CarsInterceptor from './services/cars.interceptor';

import CarsCarouselController from './controllers/carsCarouselCtrl';
import CarsFiltersController from './controllers/carsFiltersCtrl';
import CarsListController from './controllers/carsListCtrl';
import CarsMapController from './controllers/cars-map-controller';

import CarService from './services/car-service';
import CarsFactory from './services/carsFactory';
import CarsRequestDataFactory from './services/carsRequestDataFactory';
import DefaultTimeFactory from './services/defaultTimeFactory';
import PrepareCarMatrixFactory from './services/prepareCarMatrixFactory';
import TimeLocationFactory from './services/timeLocationConstructor';
import FixedMatrixHeader from './directives/fixed-matrix-header/fixed-matrix-header-module';


const MODULE_NAME = 'App.Cars';
const module = angular
    .module(MODULE_NAME, [
        'app',
        FixedMatrixHeader,
    ])
    .constant('carEvents', events)
    .controller('CarsCarouselController', CarsCarouselController)
    .controller('CarsFiltersController', CarsFiltersController)
    .controller('CarsListController', CarsListController)
    .controller('CarsMapController', CarsMapController)
    .service('carService', CarService)
    .factory('carsFactory', CarsFactory)
    .factory('carsRequestDataFactory', CarsRequestDataFactory)
    .factory('defaultTimeFactory', DefaultTimeFactory)
    .factory('prepareCarMatrixFactory', PrepareCarMatrixFactory)
    .factory('TimeLocationConstructor', TimeLocationFactory)
    .config(CarsInterceptor)
    .config(CarsRoutes);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/cars/cars-module.js